<template src="../templates/normal_fcont_204.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import FuncSearchGalleryTop from '../components/FuncSearchGalleryTop'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '204',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage,Carousel,Slide,FuncSearchRecommendLink,InfoMachineTranslation,
    FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadiPrint,AppDownloadSmartPanel,FuncSearchGalleryTop
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['204-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['204-3']}
    ]};

  }
};
</script>
<style scoped>
.onigiriaction_img {
    width: 720px;
    max-width: 100%;
    padding: 10px;
    background-color: white;
}

.subtitle {
    margin-top: 20px;
}

</style>

